import Api from '../connection';

const title = `general`;

export default {
	create(object, data) {
		return Api.applikasi.post(`${title}/${object}`, data);
	}
};
